// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"202":"406a3e12dc12b25b","6088":"116102086cf2abb6"}[chunkId] + ".js";
};